import React from "react"
import "./GridExpandTrick.css"

export default function GridExpandTrick({
  children,
}: {
  children: React.ReactNode
}) {
  return <span className="ui89-grid-expand-trick">{children}</span>
}
